<template>
  <div
    class="popup"
    :class="{
      pc: isMobile == 0 && !src,
      'popup-img-pc': isMobile == 0 && src,
      'popup-img-wap': isMobile != 0 && src
    }"
    v-show="isShow"
    @click="close()"
  >
    <span v-show="!src" class="icontemp sigh"></span>
    <div v-show="!src" class="content">
      {{ message }}
    </div>
    <img
      v-show="src"
      :src="src"
      :class="{ 'img-big-pc': isMobile == 0, 'img-big-wap': isMobile != 0 }"
    />
    <div v-show="!src" class="known" @click="close()">我知道了</div>
  </div>
</template>
<script>
import { $subscriber, interact } from "fire-wind-water";
export default {
  name: "Popup",
  data() {
    return {
      message: "您的账号已在其他地方登陆，若不是本人操作，请注意账号安全！",
      isShow: false,
      cmd: "",
      isMobile: interact.isMobile,
      timer: null,
      src: ""
    };
  },
  created() {},
  methods: {
    showMessage(message, time = 3000, cmd = "") {
      let self = this;
      if (self.isShow) {
        return;
      }
      this.message = message;
      this.isShow = true;
      self.timer = setTimeout(() => {
        self.isShow = false;
        if (cmd) {
          $subscriber.emit(cmd);
        }
      }, time);
    },
    showImage(src, time = 3000, cmd = "") {
      let self = this;
      if (self.isShow) {
        return;
      }
      this.src = src;
      this.isShow = true;
      self.timer = setTimeout(() => {
        self.isShow = false;
        if (cmd) {
          $subscriber.emit(cmd);
        }
      }, time);
    },
    close() {
      let self = this;
      this.isShow = false;
      this.src = "";
      this.message = "";
      clearTimeout(self.timer);
      if (this.cmd) {
        $subscriber.emit("close" + this.cmd);
        this.cmd = "";
      }
    }
  },
  mounted() {
    let self = this;
    $subscriber.on("showPopup", data => {
      if (data.src) {
        self.showImage(data.src, data.delay || 300000, data.cmd || "");
      } else {
        self.showMessage(data.message, data.delay || 3000, data.cmd || "");
      }
      if (data.cmd) {
        self.cmd = data.cmd;
      }
    });
  }
};
</script>

<style lang="scss">
.popup-img-pc {
  width: 100%;
  height: 100%;
  border-radius: 0;
  text-align: center;
  justify-content: center;
  display: flex;
}
.popup-img-wap {
  width: 100%;
  height: 100%;
  border-radius: 0;
  text-align: center;
  display: flex;
}
.img-big-pc {
  max-height: 100%;
  align-self: center;
  max-width: 100%;
}
.img-big-wap {
  width: 100%;
  align-self: center;
  max-height: 100%;
}
</style>
